import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginRequest } from "../redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

const LoginPage = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [userName,setUserName] = useState("")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user, token } = useSelector((state) => state.auth);
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 1) {
      toast.error("Your password must be four characters");
    }
    if (email.length > 0 && password.length > 0) {
      dispatch(loginRequest(email, password));
    }
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }
  };
  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div className="flex justify-center flex-col column items-center">
      <div className="flex w-full bg-gray-50 p-3 justify-center ">
        <h2 className="text-xl font-bold text-center">ACCOUNT</h2>
      </div>
      <div className="w-full max-w-md p-6 my-16 rounded-lg">
        <form onSubmit={handleSubmit}>
          <div className="relative mb-6">
            <input
              type="text"
              id="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="username"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
    ${setEmail ? "top-2 scale-75" : "top-5 scale-100"}
    peer-focus:top-2 peer-focus:scale-75`}
            >
              UserName or E-mail <span className="text-red-500">*</span>
            </label>
          </div>

          {/* Password Field */}
          <div className="relative mb-6">
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="password"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
    ${password ? "top-2 scale-75" : "top-5 scale-100"}
    peer-focus:top-2 peer-focus:scale-75`}
            >
              Password <span className="text-red-500">*</span>
            </label>
          </div>

          {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
            <div className="mb-4">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
            </div>
          ) : null}
          <div className="mb-4 text-left">
            <Link to="/forgot-password">
              <p className="text-sm underline hover:text-gray-200">
                Forgot your password?
              </p>
            </Link>
          </div>
          <button
            type="submit"
            className={`w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Signing In..." : "SIGN IN"}
          </button>
        </form>
        <div className="mt-4 text-left">
          <p className="text-sm hover:text-gray-200">New to Mishaaf?</p>
          <button
            onClick={() => navigate("/register")}
            className="w-full mt-2 py-2 bg-white border border-gray-300 text-black rounded-xl hover:bg-gray-100 transition"
          >
            CREATE ACCOUNT
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
